import { render, staticRenderFns } from "./SignalsView.vue?vue&type=template&id=9644d8c8&scoped=true&"
import script from "./SignalsView.vue?vue&type=script&lang=js&"
export * from "./SignalsView.vue?vue&type=script&lang=js&"
import style0 from "./SignalsView.vue?vue&type=style&index=0&id=9644d8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9644d8c8",
  null
  
)

export default component.exports